import * as Yup from 'yup';
// import i18next from 'i18next';

export const albumMap = () => ({
  name: Yup.string()
    .trim()
    .required(),
});
